// Body of the lookup-orders-by-email ("Order Status") page: the account-page
// layout -- the brand heading, the email form rendered as a native React field
// tree, and the decorative account image. The heading / help text / image
// diverge per APP_SLUG, so they arrive pre-resolved as props from the
// server-side lookup_orders_copy hook (request-time gettext, keeping tempurca
// fr_CA translated).
import { Immutable } from "immer";
import React from "react";
import { FormFields } from "tsi-common-react/src/apps/customer-account/FormFields/index";
import {
    FORM_FIELD_SUBMIT_CLASS_NAME,
    FORM_HELP_TEXT_CLASS_NAME,
} from "tsi-common-react/src/forms/classNames";
import { useStaticURL } from "tsi-common-react/src/utils/urls";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

type IProps = Immutable<templates.LookupOrdersByEmailDocumentTemplate>;

export const LookupOrdersByEmailBody = (props: IProps): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <div className="l-capped-width">
            <div className="account-page-title">
                <h1>{props.page_heading}</h1>
            </div>

            <section className="account-page-container">
                <div>
                    <h2>{props.section_heading}</h2>
                    <div>
                        <form
                            id="lookup-orders-by-email-form"
                            className="js-kuid-form"
                            action={props.action_url}
                            method="post"
                        >
                            <p className={FORM_HELP_TEXT_CLASS_NAME}>
                                {props.help_text}
                            </p>
                            <CSRFToken />
                            <FormFields
                                fields={props.fields}
                                field_labels={props.field_labels}
                                field_errors={props.field_errors}
                                non_field_errors={props.non_field_errors}
                                showRequiredLegend
                            />
                            <div className={FORM_FIELD_SUBMIT_CLASS_NAME}>
                                <input
                                    type="submit"
                                    className="button button--full-width"
                                    value={props.submit_text}
                                />
                            </div>
                        </form>
                    </div>
                </div>
                <div>
                    <img
                        src={`${staticURL}img/accounts/${props.image}`}
                        alt={props.image_alt}
                    />
                </div>
            </section>
        </div>
    );
};
